import { useState, useEffect } from 'react'
import { getSettingCertificateBrandAPI } from '../services/setting/certificate'

function UseCertificateBrand(id) {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await getSettingCertificateBrandAPI({ paymentCerCateId: id })
      if (!resp) return
      if (resp.status) {
        const newData = resp.result.map((d) => {
          return { value: d.paymentCerBrandId, label: d.paymentCerBrand }
        })
        setData(newData)
      } else {
        setData([])
      }
    }
    if (id) getData()
  }, [id])

  return data
}

export default UseCertificateBrand
